module.exports = __webpack_public_path__ + "static/img/1.a4a48807.jpg";